export const ApplyText = {
    'intro': ['Vieunite provide a new online art community that combines an alternative ' +
    'platform for artists to sell their work digitally with an innovate digital canvas that has texture accurate display technology.',
        'To apply to become an official Vieunite Artist please complete the following information.'],
    'submit_art':'For all artists applying to become a Vieunite artist we ask them to submit 3 pieces of original artwork',

}